import './app.dependencies';

const configure= () => {
    const initInjector = angular.injector(['ng']);

    const http = initInjector.get('$http');

    return http.get('resource/config.json').then(response => {
      const configurationUri = response.data.apiUrl;
      const gTagId = response.data.googleTagId || "UA-142372838-3";

      return http.get(configurationUri)
        .then(response => {
            const config = {};
    
            for (let i = 0; i < response.data.length; i++) {
                angular.extend(config, response.data[i].configurations);
            }
            angular.module('pacaapp').constant('API_CONFIG', config);
            window.PACA_CONFIG = config;
            window.PACA_CONFIG.PACA_GOOGLE_TAG_ID = gTagId;
        });
    })
};

configure()
    .then(() => {
        angular.element(document).ready(() =>
            angular.bootstrap(document, ['pacaapp']));
    })
    .catch(errorResponse => {
        // TODO: Handle error case
    });




// WEBPACK FOOTER //
// ./app/app.bootstrap.js